import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import addEventListener from 'rc-util/lib/Dom/addEventListener';

export default class Handle extends React.Component {
    state = {
        clickFocused: false,
        changeProcStyle: {},
    }

    componentDidMount() {
        this.onMouseUpListener = addEventListener( document, 'mouseup', this.handleMouseUp );
    }

    componentWillUnmount() {
        if ( this.onMouseUpListener ) {
            this.onMouseUpListener.remove();
        }
    }

    setHandleRef = ( node ) => {
        this.handle = node;
    };

    setClickFocus( focused ) {
        this.setState( { clickFocused: focused } );
    }

    handleMouseUp = () => {
        if ( document.activeElement === this.handle ) {
            this.setClickFocus( true );
        }
    }

    handleBlur = () => {
        this.setClickFocus( false );
    }

    handleKeyDown = () => {
        this.setClickFocus( false );
    }

    clickFocus() {
        this.setClickFocus( true );
        this.focus();
    }

    focus() {
        this.handle.focus();
    }

    blur() {
        this.handle.blur();
    }

    handleChange = () => {
    }

    moveMouse = () => {
        this.setState( { changeProcStyle: { ...this.props.changeprocstylestatic } } );
    }

    moveLeve = () => {
        this.setState( { changeProcStyle: { ...this.props.changeprocstyleactive } } );
    }

    render() {
        const {
            prefixCls, vertical, offset, style, disabled, min, max, value, tabIndex, ...restProps
        } = this.props;

        const className = classNames(
            this.props.className,
            {
                [ `${ prefixCls }-handle-click-focused` ]: this.state.clickFocused,
            }
        );

        const postionStyle = vertical ? { bottom: `${ offset }%` } : { left: `${ offset }%` };
        const elStyle = {
            ...style,
            ...postionStyle,
            ...this.state.changeProcStyle
        };

        return (
            <div
                ref={ this.setHandleRef }
                tabIndex={ disabled ? null : ( tabIndex || 0 ) }
                { ...restProps }
                className={ className }
                style={ elStyle }
                onBlur={ this.handleBlur }
                onKeyDown={ this.handleKeyDown }
                onChange={ this.handleChange }
                onMouseMove={ this.moveMouse }
                onMouseOut={ this.moveLeve }
                role='slider'
                aria-valuemin={ min }
                aria-valuemax={ max }
                aria-valuenow={ value }
                aria-disabled={ !!disabled }
            />
        );
    }
}

Handle.propTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    changeprocstylestatic: PropTypes.object,
    changeprocstyleactive: PropTypes.object,
    vertical: PropTypes.bool,
    offset: PropTypes.number,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
    tabIndex: PropTypes.number,
    focusStyle: PropTypes.object,
    keyDownStyle: PropTypes.object,
};
